<style lang="scss" scoped>
@screen mobile {
.section {
  &__body>article>header {
      @apply hidden;
  }
}
}
</style>

<template>
  <article class="section section--full-width">
    <header class="section__header section__header--wrap flex-wrap">
      <h2 class="section__title">Configurar Modelos</h2>

      <p class="section__description">
        Nesta seção você pode criar e personalizar modelos de anamnese, receitas e atestados,
        além de gerenciar seus arquivos para os procedimentos padrões para cada exame.
      </p>
    </header>

    <section class="section__wrapper">
      <ul class="section__nav tabbed-nav">
        <li
          v-for="(item, index) in componentList"
          :class="(item.tabRoutes.includes(activeComponent) ? 'active' : '') + ' TOUR_MODELS_' + item.route"
          :key="`item_${index}`"
          class="tabbed-nav__item"
        >
          <router-link
            @click.native="activeComponent = item.route"
            :to="{ name: item.route }"
            class="tabbed-nav__link"
          >
            {{ item.label }}
          </router-link>
        </li>
      </ul>

      <div class="section__body">
        <transition name="fade" mode="out-in">
          <router-view :dataForm="dataForm" />
        </transition>
      </div>
    </section>
  </article>
</template>

<script>
export default {
  data () {
    return {
      componentList: [
        {
          label: 'Anamneses',
          route: 'DoctorModelsAnamnesisList',
          tabRoutes: ['DoctorModelsAnamnesisList', 'DoctorModelsAnamnesisDetails']
        },
        {
          label: 'Prescrições',
          route: 'DoctorModelsPrescriptions',
          tabRoutes: ['DoctorModelsPrescriptions']
        },
        {
          label: 'Atestados',
          route: 'DoctorModelsSicknotes',
          tabRoutes: ['DoctorModelsSicknotes']
        },
        {
          label: 'Arquivos',
          route: 'DoctorModelsFiles',
          tabRoutes: ['DoctorModelsFiles']
        }
      ],
      activeComponent: this.$router.currentRoute.name,
      dataForm: null
    }
  },
  mounted () {
    this.dataForm = this.getFormData()
  },
  methods: {
    async getFormData () {
      const url = this.fn_GET_PARENT_ROUTE(this.$route) === 'doctor'
        ? '/doctor'
        : `${this.fn_GET_PARENT_ROUTE(this.$route)}/doctor`
      const response = await this.$http.get(url, this.$store.getters.getAuthHeader)
      return response.data
    }
  }
}
</script>
